import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency } from '../../../../utils/Helpers'
import { PharmaciesDetailsFiltersContext } from '../../../../context/PharmaciesDetailsFiltersContext'
import { STATUS_DELIVERED } from '../../../../types/Order'

const GET_FINISHED_ORDERS = gql`
  query FinishedOrders ($filters: JSON) {
    ordersAggs(
      size: 0,
      filters: $filters,
      query: {
        bool: {
          filter: [
            {
              term: {
                status_translate_keyword: "${STATUS_DELIVERED}"
              }
            }
          ]
        }
      },
      aggs: {
        total: {
          sum: {
            field: "total"
          }
        }
      }
    ) {
      aggregations
    }
  }
`

const FinishedOrders = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_FINISHED_ORDERS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title="Valor total de pedidos entregues (R$)" number={formatCurrency(data.ordersAggs.aggregations.total.value)} color={Colors.green} />
  )
}

export default FinishedOrders
